import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import { useForm, Controller } from "react-hook-form";
import { Row, Col } from 'reactstrap';
import Select from "react-select";
import {
    handelCommonChangeAgent,
    handleCommonRemoveAgent,
    loadWebWidgetData,
    renderSelectableList
} from "../../Common/Appcommon";

const WebWidgetsMapping = (props) => {
    const { control } = useForm({});
    const { handleOnChange, defaultId } = props;
    const [widgetOptions, setWidgetOptions] = useState([]);
    const [selectedWidgets, setSelectedWidgets] = useState([{ value: null }]);
    const [syncWidgets, setSyncWidgets] = useState([]);

    const getWebWidgetList = async () => {
        const data = await loadWebWidgetData();
        const available = [];
        const selected = [];

        data.forEach(row => {
            const widget = { value: row.id, label: row.name };
            if (row.agent_id === defaultId) {
                selected.push({value :widget});
            }
            available.push(widget);
        });

        setWidgetOptions(available);
        if(selected && selected.length > 0){
            setSelectedWidgets(selected);
            handleOnChangeSendData(selected);
        }else{
            setSelectedWidgets([{ value: null }]);
        }
    };

    useEffect(() => {
        getWebWidgetList();
    }, [defaultId]);

    const handleOnChangeSendData = (list) => {
        const cleanList = list
            .map(item => item.value?.value ? item.value : item) // clean wrapping
            .filter(item => item); // remove nulls if any
        handleOnChange(cleanList); // Call the prop
    };

    const handleSelectChange = async (selected, index) => {
        const [updatedList, updatedSyncWidgets, updatedAvailableWidgets] =
            await handelCommonChangeAgent(selected, index, selectedWidgets, widgetOptions, syncWidgets);
        setSelectedWidgets(updatedList);
        setSyncWidgets(updatedSyncWidgets);
        setWidgetOptions(updatedAvailableWidgets);
        handleOnChangeSendData(updatedList);
    };

    const addMore = (type) => {
        setSelectedWidgets(prev => [...prev, { value: null }]);
    };

    const removeSelect = async (index) => {
        const [updatedList, updatedSyncWidgets, updatedAvailableWidgets] =
            await handleCommonRemoveAgent(index, selectedWidgets, widgetOptions);
        setSelectedWidgets(updatedList.length ? updatedList : [null]);
        setSyncWidgets(updatedSyncWidgets);
        setWidgetOptions(updatedAvailableWidgets);
        handleOnChangeSendData(updatedList.length ? updatedList : [null]);
    };

    return (
        <Row>
            <Col md={12}>
                {renderSelectableList(selectedWidgets, widgetOptions, handleSelectChange, removeSelect, addMore, 'widget',10, true, )}
            </Col>
        </Row>

    );
};

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebWidgetsMapping);
